import { VISIT_TYPES, VisitType } from "~/services";

export const normalizeVisitType = (type: string): VisitType | undefined => {
  const lower = type.toLowerCase();

  if (lower.includes("initial")) return VISIT_TYPES.INITIAL;
  if (lower.includes("follow")) return VISIT_TYPES.FOLLOW_UP;
  if (lower.includes("guide")) return VISIT_TYPES.COACH;

  return undefined;
};
